import React, {useState, useEffect} from 'react';
import "../../../css/pages/copyrights.scss";
import copyrights from './copyright.html'; 
import { useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';

function CopyRights() {
    const history = useHistory();

    return (
        <div className='copyrights-container'>
            <div className='copyrights-content'>
                <div dangerouslySetInnerHTML={{__html: copyrights}} />
            </div>
        </div>
    )
}

export default CopyRights;